import React from 'react';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { Solution } from '../components/Solution';
import { Bonuses } from '../components/Bonuses';
import { Testimonials } from '../components/Testimonials';
import { Pricing } from '../components/Pricing';
import { SimpleSteps } from '../components/SimpleSteps';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { SaleNotification } from '../components/SaleNotification';
export function Landing() {
  return <div className="min-h-screen flex flex-col w-full bg-cream text-navy font-sans selection:bg-primary/30" data-id="element-237">
      <SaleNotification data-id="element-238" />
      <main className="flex-1 flex flex-col w-full" data-id="element-239">
        <Hero data-id="element-240" />
        <Problem data-id="element-241" />
        <Solution data-id="element-242" />
        <Bonuses data-id="element-243" />
        <Testimonials data-id="element-244" />
        <Pricing data-id="element-245" />
        <SimpleSteps data-id="element-246" />
        <Guarantee data-id="element-247" />
        <FAQ data-id="element-248" />
        <FinalCTA data-id="element-249" />
      </main>
      <Footer data-id="element-250" />
    </div>;
}